import { Injectable, ComponentFactoryResolver, ViewContainerRef, TemplateRef, Injector, ViewRef, ElementRef } from '@angular/core';
import { LoaderComponent } from "../components/spinners/loader/loader.component"
import { PopupService, PopupRef } from '@progress/kendo-angular-popup';
import { Constants } from '../models/constants';
import { CommonMethods } from 'src/app/services/common.method';
import { LoaderType } from '../enums/common';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  defaultWaitSettings: number = Constants.defaultSpinnertimeout;
  constructor(private componentFactoryResolver: ComponentFactoryResolver, private injector: Injector, private popupService: PopupService, private commonmethods: CommonMethods) {
    this.defaultWaitSettings = Constants.defaultSpinnertimeout;
  }
  loaderarray: { loaderHost: ViewContainerRef, action: number, isopened: number, tabCounter: number, customTimeoutSetting: number, customLoaderType: LoaderType, inputParameter: any[] }[] = []; // action 0 means hideloader, 1 means showloader
  checkduplicateLoader: { loaderHost: ViewContainerRef, tabCounter: number }[] = [];
  executionlock: boolean = false;

  /**
   * 
   * @param loaderhost html component or page in the form of ViewContainerRef where spinner to be shown
   * @param tabCounter unique tabcounter for static or dynamically created component
   * @param timeoutsetting default time in milliseconds before showing spinner, if negative then it will use default (default = -999)
   */
  public showloader(loaderhost: ViewContainerRef, tabCounter: number, timeoutsetting: number = Constants.defaultSpinnertimeout, isGrid: boolean = false, count: number = 0, customLoaderType: LoaderType = LoaderType.circle, inputParameter: any[] = null) {
    let showNoRecords = false;
    this.loaderarray.push({ loaderHost: loaderhost, action: 1, isopened: 0, tabCounter: tabCounter, customTimeoutSetting: timeoutsetting, customLoaderType: customLoaderType, inputParameter: inputParameter });
    //first execute array  
    while (this.executionlock) {
      // wait for its completion
    }
    this.executeLoaderarray();
    return showNoRecords;
  }
  public hideLoader(loaderhost: ViewContainerRef, tabCounter: number) {
    let showNoRecords = false;
    //#region This code is executed when we believe that number of showloader per page is equal to number of hide loader, but this dont work in grid search cancelled requests
    ////this.loaderarray.unshift({ loaderHost: loaderhost, action: 0, isopened: 0 , tabCounter : tabCounter });
    ////this.executeLoaderarray('hideloader');
    //#endregion

    //#region This code believes that there can be any number of showspinners but in the last there must be hide loader for same page irrespective of their count mismatch
    // if (loaderhost.element.nativeElement.nodeName.toString().toLocaleLowerCase() == "kendo-grid") {
    //   if (!CommonMethods.CheckNullOrUndefined(loaderhost.element.nativeElement.querySelector('tr.k-grid-norecords'))) {
    //     const imgElem = loaderhost.element.nativeElement.querySelector('tr.k-grid-norecords > td > img');
    //     if (!CommonMethods.CheckNullOrUndefined(imgElem))
    //       loaderhost.element.nativeElement.querySelector('tr.k-grid-norecords > td').removeChild(imgElem);
    //   }
    // }
    this.ClearTabData(tabCounter, loaderhost);
    //#endregion
    return showNoRecords = true;
  }
  public ClearTabData(tabCounter: number, loaderhost: ViewContainerRef = null) {
    let checkifLoaderPresent: number = $('kendo-popup').find('app-loader').length;
    $('kendo-popup').find('app-loader').remove();
    //#region Code to take care of rewriting the Default No record text for grid after count of rows comes to 0 again
    if (!CommonMethods.CheckNullOrUndefined(loaderhost)) {
      if (loaderhost.element.nativeElement.nodeName.toString().toLocaleLowerCase() == "kendo-grid" ||
        loaderhost.element.nativeElement.nodeName.toString().toLocaleLowerCase() == "kendo-dropdownlist") {
        let timeoutMaxTry: number = 0;
        let waitforNoRecordTemplateToAppear = setInterval(() => {
          if (!CommonMethods.CheckNullOrUndefined(loaderhost.element.nativeElement.querySelector('tr.k-grid-norecords > td'))
            && CommonMethods.CheckNullOrUndefined(loaderhost.element.nativeElement.querySelector('tr.k-grid-add-row > td'))
            && CommonMethods.CheckNullOrUndefined(loaderhost.element.nativeElement.querySelector('tr.k-grid-edit-row > td'))) {
            loaderhost.element.nativeElement.querySelector('tr.k-grid-norecords > td').innerHTML = Constants.defaultNoRowGridMessge;
            if (timeoutMaxTry >= 8) {
              clearInterval(waitforNoRecordTemplateToAppear);
              clearInterval(waitforNoRecordTemplateToAppear);
            }
            timeoutMaxTry = timeoutMaxTry + 1;
          }
          // When the search shows record and if search still continues and api do not return any record then following code shows "no record found"
          else if (checkifLoaderPresent > 1 && !CommonMethods.CheckNullOrUndefined(this.popupService.rootViewContainerNode.querySelector('kendo-popup')) &&
            this.popupService.rootViewContainerNode.querySelector('kendo-popup').getElementsByClassName("k-nodata").length > 0) {
            let element = this.popupService.rootViewContainerNode.querySelector('kendo-popup').getElementsByClassName("k-nodata")[0];
            if (element.childElementCount == 0) {
              let noRecord: any = document.createElement("span");
              noRecord.innerHTML = Constants.defaultNoRowDropdownMessge;
              element.innerHTML = "";
              element.insertAdjacentElement("beforeend", noRecord);
            }
          }
          else {
            clearInterval(waitforNoRecordTemplateToAppear);
            clearInterval(waitforNoRecordTemplateToAppear);
          }
        }, 150);
      }
    }
    //#endregion
    while (this.loaderarray.find(x => x.tabCounter == tabCounter) != undefined) {
      let indexofView: number = this.loaderarray.findIndex(x => x.tabCounter == tabCounter);
      let closedTabRefViewContainer = this.loaderarray[indexofView].loaderHost;
      this.loaderarray.splice(indexofView, 1);
      if (this.checkduplicateLoader.findIndex(x => x.tabCounter == tabCounter || x.loaderHost == closedTabRefViewContainer) > -1) {
        let indexOfLoader: number = this.checkduplicateLoader.findIndex(x => x.tabCounter == tabCounter || x.loaderHost == closedTabRefViewContainer);
        this.checkduplicateLoader.splice(indexOfLoader, 1);
        closedTabRefViewContainer.remove();
      }
    }
    while (this.loaderarray.find(x => x.loaderHost == loaderhost) != undefined) {
      let indexofView: number = this.loaderarray.findIndex(x => x.loaderHost == loaderhost);
      let closedTabRefViewContainer = this.loaderarray[indexofView].loaderHost;
      this.loaderarray.splice(indexofView, 1);
      if (this.checkduplicateLoader.findIndex(x => x.tabCounter == tabCounter || x.loaderHost == closedTabRefViewContainer) > -1) {
        let indexOfLoader: number = this.checkduplicateLoader.findIndex(x => x.tabCounter == tabCounter || x.loaderHost == closedTabRefViewContainer);
        this.checkduplicateLoader.splice(indexOfLoader, 1);
        closedTabRefViewContainer.remove();
      }
    }
  }
  public handleOverlay(elements: ElementRef<HTMLElement>[], show: boolean = false) {
    for(let element of elements) {
      let nativeElement = element.nativeElement;
      nativeElement.style.position = show? "relative" : "initial";
      if (show) {
        let element = document.createElement('div');
        element.className = "overlay";
        nativeElement.appendChild(element);
      } else {
        nativeElement.removeChild(element.nativeElement.querySelector('.overlay'));
      }
    }
  }
  //#region Private Methods
  private executeLoaderarray() {
    this.executionlock = true;
    this.loaderarray.forEach((value: { loaderHost: ViewContainerRef, action: number, isopened: number, tabCounter: number, customTimeoutSetting: number, customLoaderType: LoaderType, inputParameter: any[] }, index: number) => {
      if (value.action == 1 && value.isopened == 0) {
        this.showLoaderOnPage(value.loaderHost, value.tabCounter, value.customTimeoutSetting, value.customLoaderType, value.inputParameter);
      }
      else if (value.action == 0) {
        this.hideLoaderfrompage(value.loaderHost);
      }
    });
    this.executionlock = false;
  }
  private createComponentForPage(loaderhost: ViewContainerRef, tabCounter: number, customLoaderType: LoaderType = LoaderType.circle, inputParameter: any[] = null) {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(LoaderComponent);
    if (loaderhost.element.nativeElement.nodeName.toString().toLocaleLowerCase() == "kendo-dropdownlist") {
      let eee: ViewContainerRef = Object.create(loaderhost);
      const componentRef = eee.createComponent(componentFactory);
      let dropdownNoData: number = this.popupService.rootViewContainerNode.querySelector('kendo-popup').getElementsByClassName("k-nodata").length;
      componentRef.instance.loaderType = dropdownNoData > 0 ? LoaderType.dot : customLoaderType;
      if (!CommonMethods.CheckNullOrUndefined(inputParameter)) {
        if (inputParameter.length > 0)
          for (var key in inputParameter) {
            componentRef.instance[Object.keys(inputParameter[key]).toString()] = Object.values(inputParameter[key]).toString();
          }
      }
      if (dropdownNoData > 0) {
        let element: HTMLElement = componentRef.instance["_elementRef"].nativeElement;
        element.style.position = "absolute";
        element.style.backgroundColor = "#fff";
        element.style.width = "100%";
        let noRecord: any = document.createElement("span");
        noRecord.innerHTML = Constants.defaultNoRowDropdownMessge;
        let spinnerElement = this.popupService.rootViewContainerNode.querySelector('kendo-popup').getElementsByClassName("k-nodata")[0];
        spinnerElement.innerHTML = "";
        spinnerElement.insertAdjacentElement("beforeend", noRecord);
        spinnerElement.insertAdjacentElement("beforeend", element);
      }
      else {
        let spinnerElement = this.popupService.rootViewContainerNode.querySelector('kendo-popup');
        spinnerElement.insertAdjacentElement("beforeend", componentRef.instance["_elementRef"].nativeElement);
      }
    }
    else {
      if (this.checkduplicateLoader.findIndex(x => x.tabCounter == tabCounter || x.loaderHost == loaderhost) <= -1) {
        this.checkduplicateLoader.push({ tabCounter: tabCounter, loaderHost: loaderhost });
        // here check if modal is opened create its component else create component of page
        if (loaderhost.element.nativeElement.nodeName.toString().toLocaleLowerCase() == "kendo-grid") {
          // if there is no row and grid is not opened in editing/add mode then show dot spinner
          if (!CommonMethods.CheckNullOrUndefined(loaderhost.element.nativeElement.querySelector('tr.k-grid-norecords > td'))
            && CommonMethods.CheckNullOrUndefined(loaderhost.element.nativeElement.querySelector('tr.k-grid-add-row > td'))
            && CommonMethods.CheckNullOrUndefined(loaderhost.element.nativeElement.querySelector('tr.k-grid-edit-row > td'))
          ) {
            let eee: ViewContainerRef = Object.create(loaderhost);
            const componentRef = eee.createComponent(componentFactory);
            componentRef.instance.loaderType = LoaderType.dot;
            if (!CommonMethods.CheckNullOrUndefined(inputParameter)) {
              if (inputParameter.length > 0)
                for (var key in inputParameter) {
                  componentRef.instance[Object.keys(inputParameter[key]).toString()] = Object.values(inputParameter[key]).toString();
                }
            }
            loaderhost.element.nativeElement.querySelector('tr.k-grid-norecords > td').innerHTML = "";
            loaderhost.element.nativeElement.querySelector('tr.k-grid-norecords > td').insertAdjacentElement("beforeend", componentRef.instance["_elementRef"].nativeElement);
          }
          else {
            const componentRef = loaderhost.createComponent(componentFactory);
            componentRef.instance.loaderType = customLoaderType;
            if (!CommonMethods.CheckNullOrUndefined(inputParameter)) {
              if (inputParameter.length > 0)
                for (var key in inputParameter) {
                  componentRef.instance[Object.keys(inputParameter[key]).toString()] = Object.values(inputParameter[key]).toString();
                }
            }
            const  loaderHostElement : HTMLElement = loaderhost.element.nativeElement;
            const contentBoxEle = loaderHostElement.parentElement.offsetParent;
            if (contentBoxEle) {
              contentBoxEle.appendChild(componentRef.instance["_elementRef"].nativeElement);
            }
          }
        }
        else if (loaderhost.element.nativeElement.querySelector('.modal-content') != null) {
          let eee: ViewContainerRef = Object.create(loaderhost);
          const componentRef = eee.createComponent(componentFactory);
          componentRef.instance.loaderType = customLoaderType;
          loaderhost.element.nativeElement.querySelector('.modal-content').insertAdjacentElement("beforeend", componentRef.instance["_elementRef"].nativeElement);
        }
        else {
          const componentRef = loaderhost.createComponent(componentFactory);
          componentRef.instance.loaderType = customLoaderType;
          if (!CommonMethods.CheckNullOrUndefined(inputParameter)) {
            if (inputParameter.length > 0)
              for (var key in inputParameter) {
                componentRef.instance[Object.keys(inputParameter[key]).toString()] = Object.values(inputParameter[key]).toString();
              }
          }
        }
      }
    }
  }
  private showLoaderOnPage(loaderht: ViewContainerRef, tabCounter: number, settimeoutTimer: number = -999, customLoaderType: LoaderType = LoaderType.circle, inputParameter: any[] = null) { // negative number means use default timeout settings
    let timeoutSetting: number = this.defaultWaitSettings;
    if (settimeoutTimer >= 0) {
      timeoutSetting = settimeoutTimer;
    }

    if (!CommonMethods.CheckNullOrUndefined(loaderht)) {
      if (loaderht.element.nativeElement.nodeName.toString().toLocaleLowerCase() == "kendo-grid") {
        if (!CommonMethods.CheckNullOrUndefined(loaderht.element.nativeElement.querySelector('tr.k-grid-norecords > td'))) {
          loaderht.element.nativeElement.querySelector('tr.k-grid-norecords > td').innerHTML = "";
        }
      }
    }

    setTimeout(() => {
      let index: number = this.loaderarray.findIndex(x => x.loaderHost == loaderht && x.action == 1 && x.isopened == 0);
      if (index > -1) {
        this.loaderarray[index].isopened = 1;
        this.createComponentForPage(loaderht, tabCounter, customLoaderType, inputParameter);
      }
      else {
      }
    }, timeoutSetting);
 
  }
  private hideLoaderfrompage(loaderht: ViewContainerRef) {
    if (loaderht.element.nativeElement.nodeName.toString().toLocaleLowerCase() == "kendo-dropdownlist") {
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(LoaderComponent);
      let eee: ViewContainerRef = Object.create(loaderht);
      const componentRef = eee.createComponent(componentFactory);
      componentRef.instance.showLoader = true;
      this.popupService.rootViewContainerNode.querySelector('kendo-popup').removeChild(componentRef.instance["_elementRef"].nativeElement);
    }
    else {
      let indexofLoaderToHide: number = this.loaderarray.findIndex(x => x.loaderHost == loaderht && x.action == 0);
      if (indexofLoaderToHide > -1) {
        this.loaderarray.splice(indexofLoaderToHide, 1);
      }
      else {
      }

      let indexofLoaderToShow: number = this.loaderarray.findIndex(x => x.loaderHost == loaderht && x.action == 1);
      if (indexofLoaderToShow > -1) {
        this.loaderarray.splice(indexofLoaderToShow, 1);
      }
      else {
      }
    }
  }
  //#endregion
}
